module.exports = __webpack_public_path__ + "img/SketchPng86df24381708c9d2cf8265da9462d9c7945bc0cb9e77c2c4db03865982829c23.776792d9.png";